import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const CaseHistoryCard = ({ cases }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    const colors = {
      'Brouillon': 'bg-muted text-muted-foreground',
      'Soumis': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
      'En Révision': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
      'En Cours': 'bg-primary/10 text-primary',
      'Terminé': 'bg-success/10 text-success',
      'En Attente': 'bg-warning/10 text-warning',
      'Annulé': 'bg-error/10 text-error'
    };
    return colors[status] || 'bg-muted text-muted-foreground';
  };

  const handleCaseClick = (caseId) => {
    navigate(`/case-detail/${caseId}`); // Utiliser l'ID UUID
  };

  if (!cases || cases.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 shadow-card">
        <h2 className="text-lg font-semibold text-foreground mb-4">Historique des Conceptions</h2>
        <div className="text-center py-8">
          <Icon name="Briefcase" size={48} className="text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">Aucune conception pour ce patient</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Historique des Conceptions</h2>
        <span className="text-sm text-muted-foreground">
          {cases.length} conception{cases.length > 1 ? 's' : ''} au total
        </span>
      </div>
      <div className="space-y-3">
        {cases.map((caseItem) => (
          <div
            key={caseItem.id}
            onClick={() => handleCaseClick(caseItem.id)}
            className="p-4 bg-muted rounded-lg hover:bg-muted/80 transition-colors duration-200 cursor-pointer"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-sm font-semibold text-foreground">{caseItem.caseNumber}</h3>
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(caseItem.status)}`}>
                    {caseItem.status}
                  </span>
                  {caseItem.urgent && (
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-error text-error-foreground">
                      <Icon name="AlertCircle" size={12} className="mr-1" />
                      Urgent
                    </span>
                  )}
                </div>
                <p className="text-xs text-muted-foreground">{caseItem.treatmentType}</p>
              </div>
              <Icon name="ChevronRight" size={20} className="text-muted-foreground" />
            </div>

            <div className="grid grid-cols-2 gap-4 text-xs">
              <div>
                <p className="text-muted-foreground mb-1">Date de Création</p>
                <p className="text-foreground font-medium">{caseItem.createdDate}</p>
              </div>
              <div>
                <p className="text-muted-foreground mb-1">Phase Actuelle</p>
                <p className="text-foreground font-medium">{caseItem.currentPhase}</p>
              </div>
              <div>
                <p className="text-muted-foreground mb-1">Dentiste</p>
                <p className="text-foreground font-medium">{caseItem.dentist}</p>
              </div>
              <div>
                <p className="text-muted-foreground mb-1">Dernière Mise à Jour</p>
                <p className="text-foreground font-medium">{caseItem.lastUpdate}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaseHistoryCard;